import { registrationService } from './service'
import { createFetchHook } from 'acato-utils'

export const registerServiceHooks = createFetchHook(registrationService)
